export default __webpack_public_path__ + "static/media/linkerd.f49b3879.svg";